export const GET_THEMES_CALL = 'GET_THEMES_CALL'
export const GET_THEMES_DONE = 'GET_THEMES_DONE'
export const GET_THEMES_FAIL = 'GET_THEMES_FAIL'

export const UPDATE_THEMES_CALL = 'UPDATE_THEMES_CALL'
export const UPDATE_THEMES_DONE = 'UPDATE_THEMES_DONE'
export const UPDATE_THEMES_FAIL = 'UPDATE_THEMES_FAIL'

export const SET_THEMES = 'SET_THEMES'